"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longDateTimeFormatWithTimeZone = void 0;
var date_fns_tz_1 = require("date-fns-tz");
function longDateTimeFormatWithTimeZone(date) {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var zonedDate = (0, date_fns_tz_1.utcToZonedTime)(new Date(date), timeZone);
    return (0, date_fns_tz_1.format)(zonedDate, 'M/d/yyyy h:mm a z', { timeZone: timeZone });
}
exports.longDateTimeFormatWithTimeZone = longDateTimeFormatWithTimeZone;
